import React from "react";
import PropTypes from "prop-types";
import { Modal, Tooltip, Typography } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import TSTable from "../../components/common/TSTable";
import { URL_INTERFACE_AX } from "../../constance/urls";
import moment from "moment";
import { ellipsisString } from "../../utils/stringFormat";
import * as _ from "lodash";
export default function InterfaceAXHistoryModal(props) {
  const { type, open, onClose } = props;
  const { Title } = Typography;
  const { t } = useTranslation();
  const tableRef = React.useRef();

  const columns = React.useMemo(() => [
    {
      title: t("date"),
      dataIndex: "created",
      render: (text, record) =>
        moment(record.created).format("DD/MM/YYYY HH:mm"),
    },
    {
      title: t("interface_ax.reference"),
      dataIndex: "refs",
      render: (text, record) => (
        <Tooltip
          title={record.refs.map((e, index) => (
            <div key={index}>{e}</div>
          ))}
        >
          <span>{ellipsisString(record.refs.join(", "), 30)}</span>
        </Tooltip>
      ),
    },
    {
      title: t("interface_ax.ref_params"),
      dataIndex: "ref_params",
      render: (text, record) =>
        Object.keys(record.ref_params || {}).map((key) => (
          <div key={key}>{`${t(`interface_ax.params.${key}`)}: ${_.get(
            record.ref_params,
            key,
            "-"
          )}`}</div>
        )),
    },
    {
      title: t("status"),
      dataIndex: "is_success",
      render: (text, record) => (
        <div style={{ textAlign: "center" }}>
          {record.is_success ? (
            <CheckOutlined style={{ color: "green" }} />
          ) : (
            <CloseOutlined style={{ color: "red" }} />
          )}
        </div>
      ),
    },
    {
      title: t("detail"),
      dataIndex: "response_text",
      render: (text, record) => (
        <Tooltip title={record.response_text}>
          <span>{ellipsisString(record.response_text, 30)}</span>
        </Tooltip>
      ),
    },
  ]);

  React.useEffect(() => {
    if (
      open &&
      tableRef.current &&
      typeof tableRef.current.refetch === "function"
    ) {
      tableRef.current.refetch();
    }
  }, [open]);

  return (
    <Modal
      centered={false}
      open={open}
      onCancel={onClose}
      footer={null}
      width={1000}
    >
      <Title level={3}>{t("interface_ax.history")}</Title>
      <span className="exportItemList-table">
        <TSTable
          ref={tableRef}
          columns={columns}
          url={URL_INTERFACE_AX.INTERFACE_TRANSACTION}
          manual
          showPagination
          params={{ type: type }}
          scroll={{ x: 1000 }}
        />
      </span>
    </Modal>
  );
}

InterfaceAXHistoryModal.propTypes = {
  type: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

InterfaceAXHistoryModal.defaultProps = {
  type: "",
  open: false,
  onClose: () => null,
};
